import { useEffect, useState } from "react";

import SimpleModal from "../../../../../shared/components/simple-modal/simple-modal";
import TextArea from "../../../../../shared/components/text-area/text-area";
import TextInput from "../../../../../shared/components/text-input/text-input";
import { IEnumerationOption } from "../../../../../shared/definitions/datatypes";
import { noop } from "../../../../utils";
import { ITableRowData } from "../../../data-table/data-table";
import "./text-widget-modal.scss";
import { createUUID } from "../../../../../shared/utils/utils";
import SearchInput from "../../../search-input/search-input";
import { IWidgetModalProps } from "../../widget-utils";
import { IHeaderWidget } from "../../widgets/header-widget/header-widget";
import { ITextWidget } from "../../widgets/text-widget/text-widget";

export interface ITextWidgetModal {
  type: "text";
}

const TextWidgetModal = ({modalOpen, widgetData, onWidgetChanged}: IWidgetModalProps<ITextWidget | IHeaderWidget>) => {
  const [modalData, setModalData] = useState<ITableRowData>(widgetData || {id: ""});
  const [showModal, setShowModal] = useState(modalOpen || false);

  useEffect(() => {
    setShowModal(modalOpen || false);
    setModalData(widgetData || {id: ""});
  }, [modalOpen, widgetData]);

  const handleModalOnChange = (targetVal: string, inputKey: string) => {
    setModalData({...modalData, [inputKey]: targetVal});
  };

  const handleSearchInputChange = (selectedOption: IEnumerationOption | undefined) => {
    if (!selectedOption) {
      setModalData({...modalData, type: ""});
      return;
    }
    
    setModalData({...modalData, type: selectedOption.id});
  };

  const renderTextModalBody = () => {
    return <div>
      <SearchInput
        label="Text type"
        handleOnChange={handleSearchInputChange}
        data={[
          {id: "text", name: "Text"},
          {id: "header", name: "Header"}
        ]}
        inputKey="textType"
        required={true}
        selectedOption={modalData?.type || ""}
      />
      { modalData.type === "text" &&
        <TextArea
          key="text"
          id="text"
          inputKey="text"
          label="Text"
          required={true}
          defaultValue={modalData.text || ""}
          handleOnChange={handleModalOnChange}
        />
      }
      { modalData.type === "header" &&
        <TextInput
          key="text"
          name="text"
          type="text"
          id="text"
          label="Text"
          required={true}
          inputKey="text"
          value={modalData.text || ""}
          handleOnChange={handleModalOnChange}
          controlled={true}
        />
      }
    </div>;
  };

  const handleModalClosed = () => {
    onWidgetChanged(undefined);
    setShowModal(false);
    setModalData({id:""});
  };

  const handleModalSubmit = () => {
    onWidgetChanged({
      id: modalData["id"] || createUUID(),
      type: modalData["type"],
      modalType: "text",
      text: modalData["text"]
    });
    setShowModal(false);
    setModalData({id:""});
  };

  return <div>
    <span className="textWidgetModal-layoutButton" onClick={() => setShowModal(true)}>
      Text +
    </span>
    <SimpleModal allowScrollOnBody={false} mode="Text" onModalClickHandler={noop} modalBody={renderTextModalBody()} buttonText={"Add"} handleModalClosed={handleModalClosed} handleSubmit={handleModalSubmit} show={showModal}/>
  </div>;
};
export default TextWidgetModal;